import { authentication } from '@dpgradio/creative'
import store from '../store'

export async function setAppCallbacks() {
  authentication.initialize()

  if (window.__earlyNativeEvents) {
    for (const [name, args] of Object.entries(window.__earlyNativeEvents)) {
      if (typeof window[name] === 'function') {
        window[name](args)
      }
    }
    delete window.__earlyNativeEvents
  }

  authentication.onRadioTokenChange(() => {
    store.dispatch('checkUserSignedIn')
  })
}
